export default {
	baseURL: process.env.VUE_APP_BASE_URL,
	assetsURL: process.env.VUE_APP_ASSETS_URL,
	wsURL: process.env.VUE_APP_WS_URL,
	contentType: 'application/json',
	statusName: 'status',
	credentials: 'include',
	tokenHeaderName: 'auth',
	tokenName: 'token',
	messageName: 'message',
	storagePrefix: 'eurogogo_strip_'
}
